// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root___Yauf","header":"Messages_header__3aOOO"};